exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".evaluation-dialog[data-v-5da0afdf] .ivu-modal-body{padding:0 16px 16px 16px}.evaluation-dialog[data-v-5da0afdf] .ivu-modal-header{padding:16px 16px 12px 16px}.evaluation-dialog[data-v-5da0afdf] .mtd-modal{min-width:0}", ""]);
